var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyInboxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 30,
    viewBox: "0 0 51 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2872 17.0867L40.6685 0.355962C40.6078 0.250566 40.505 0.160494 40.3732 0.0971339C40.2413 0.033774 40.0864 -2.86933e-05 39.9278 1.82752e-08H11.0717C10.9133 8.53406e-05 10.7585 0.0339412 10.6268 0.0972941C10.4951 0.160647 10.3925 0.250657 10.3318 0.355962L0.713087 17.0867L0.651367 17.3077V27.6923C0.651367 28.3043 0.989167 28.8913 1.59045 29.3241C2.19174 29.7569 3.00726 30 3.85761 30H47.1419C47.9922 30 48.8078 29.7569 49.409 29.3241C50.0103 28.8913 50.3481 28.3043 50.3481 27.6923V17.3077L50.2872 17.0867ZM11.6071 1.15385H39.3924L48.3442 16.7308H33.5154C33.3028 16.7308 33.0989 16.7916 32.9486 16.8997C32.7982 17.0079 32.7138 17.1547 32.7138 17.3077V21.9231H18.2857V17.3077C18.2857 17.1547 18.2013 17.0079 18.0509 16.8997C17.9006 16.7916 17.6967 16.7308 17.4841 16.7308H2.65527L11.6071 1.15385Z",
    fill: "#CED4DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInboxIcon);
export default __webpack_public_path__ + "static/media/empty-inbox-icon.d8a702d240a950c7e31fcc10586e2192.svg";
export { ForwardRef as ReactComponent };